<template>
  <v-dialog
    ref="date_picker_dialog"
    v-model="show"
    :return-value.sync="item"
    persistent
    :width="width"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        v-model="item"
        :label="label"
        :class="textFieldClass"
        readonly
        color="companyPrimary"
        append-icon="mdi-calendar"
        :dense="dense"
        :outlined="outlined"
        :persistent-hint="persistentHint"
        :hint="hint"
        :disabled="disabled"
        :rules="rules"
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="item"
      color="companyPrimary"
      scrollable
      show-adjacent-months
      :show-current="showCurrent"
      :first-day-of-week="firstDayOfWeek"
      :min="min"
      :max="max"
      :active-picker.sync="activePickerSync"
    >
      <v-spacer />
      <BaseButtonBack @click="show = false" />
      <BaseButtonSave text @click="onSave">OK</BaseButtonSave>
    </v-date-picker>
  </v-dialog>
</template>

<script>
import BaseButtonBack from "@/components/base/button/BaseButtonBack.vue";
import BaseButtonSave from "@/components/base/button/BaseButtonSave.vue";

export default {
  name: "BaseDatePicker",
  components: {
    BaseButtonBack,
    BaseButtonSave,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "290px",
    },
    showCurrent: {
      type: Boolean,
      default: false,
    },
    firstDayOfWeek: {
      type: Number,
      default: 1,
    },
    persistentHint: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    min: {
      type: String,
      default: "",
    },
    max: {
      type: String,
      default: "",
    },
    rules: {
      type: Array,
      default: () => [],
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    textFieldClass: {
      type: String,
      default: "",
    },
    activePicker: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      show: false,
      activePickerSync: null,
    };
  },
  computed: {
    item: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    show(val) {
      this.activePicker &&
        val &&
        setTimeout(() => (this.activePickerSync = this.activePicker));
    },
  },
  methods: {
    onSave() {
      this.$refs.date_picker_dialog.save(this.item);
    },
  },
};
</script>
